const translations = {
    applications: 'Applications',
    editBoundary: 'Edit Boundary',
    linkedEntities: 'Linked Entities'
};

export default translations;
